(() => {
  const root = document.getElementById('cp-homepage');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const $ = s => root.querySelector(s);
  const $$ = s => [...root.querySelectorAll(s)];
  const config = JSON.parse($('[data-homepage-config]').textContent);
  const shortScreen = window.matchMedia('(max-height: 820px)');
  const manualStages = () => mobile.matches || shortScreen.matches || motionOff;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 760px)');
  let motionOff = reduced.matches, stage = -1, scrollFrame = 0, activeFilm;
  const growth = $('#grow');
  const states = [
    {title:'A home called Portal.',copy:'One Pod, one Nest and a Base. A compact place to hide, rest and watch the world.',spec:'27 in tall · No wall attachment required',label:'PORTAL',subtitle:'A compact beginning.',height:'27 in',alt:'Portal: Base, Pod and Nest. Approximately 27 inches tall.'},
    {title:'Add another possibility.',copy:'Keep your Base, Pod and Nest. Add one Large Spacer and one Pod to create a taller configuration.',spec:'Add 1 Pod + 1 Large Spacer + 2 wall brackets',label:'THE NEW PIECES',subtitle:'More climbing. Another hideaway.',height:'',alt:'Expansion view: retain the Portal modules and add one Large Spacer and one Pod. The Nest is lifted aside for assembly.'},
    {title:'Hello, Blossom.',copy:'Two hideaways, a climbing section and the same favourite Nest. A bigger world, built on what you already have.',spec:'67 in tall · Wall attachment required · 2 brackets',label:'BLOSSOM',subtitle:'Their world, a little bigger.',height:'67 in',alt:'Blossom: Base, Pod, Large Spacer, Pod and Nest. Approximately 67 inches tall. Two wall brackets required.'}
  ];
  function updateStage(next, force = false) {
    next = Math.max(0, Math.min(2,next));
    if (stage === next && !force) return;
    stage = next; const data = states[next];
    $('#step-number').textContent = `0${next+1} / 03`;
    $('#step-title').textContent = data.title; $('#step-copy').textContent=data.copy;
    $('#step-spec').textContent=data.spec; $('#scene-label').textContent=data.label;
    $('#scene-subtitle').textContent=data.subtitle; $('#scene-height').textContent=data.height;
    $('.growth-scene').dataset.stage=String(next); $('#tower').setAttribute('aria-label',data.alt);
    $$('[data-stage][aria-pressed]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.stage)===next)));
    if(manualStages()) $('.growth-progress>span').style.width=`${(next+1)/3*100}%`;
  }
  function readScroll() {
    scrollFrame=0;
    if(manualStages()) return;
    const rect=growth.getBoundingClientRect(),distance=growth.offsetHeight-window.innerHeight;
    if(rect.top>0 || rect.bottom<0 || distance<=0) return;
    const p=Math.max(0,Math.min(1,-rect.top/distance));
    updateStage(p<.30?0:p<.68?1:2);
    $('.growth-progress>span').style.width=`${p*100}%`;
  }
  function selectStage(next) {
    if (!manualStages()) {
      const top = growth.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({top:top+[.06,.47,.85][next]*(growth.offsetHeight-window.innerHeight),behavior:'smooth'});
    }
    updateStage(next);
  }
  updateStage(0);
  window.addEventListener('scroll',()=>{if(!scrollFrame)scrollFrame=requestAnimationFrame(readScroll)},{passive:true});
  $$('[data-stage][aria-pressed]').forEach(b=>b.addEventListener('click',()=>selectStage(Number(b.dataset.stage))));
  function setMotion() {
    root.classList.toggle('no-motion',motionOff);
    $('.motion-toggle').textContent=motionOff?'Motion off':'Motion on';
    $('.motion-toggle').setAttribute('aria-pressed',String(motionOff));
  }
  setMotion();
  $('.motion-toggle').addEventListener('click',()=>{const keepInView=growth.getBoundingClientRect().top<window.innerHeight;motionOff=!motionOff;setMotion();updateStage(stage,true);if(keepInView&&!mobile.matches)growth.scrollIntoView({block:'start',behavior:'instant'});});
  reduced.addEventListener('change',event=>{motionOff=event.matches;setMotion();updateStage(stage,true);});
    const resizeStages=()=>{updateStage(stage,true);readScroll();};
  mobile.addEventListener('change',resizeStages);
  shortScreen.addEventListener('change',resizeStages);
  window.addEventListener('resize',resizeStages,{passive:true});

  async function renderModules() {
    const loaded=await window.CatterpodPhotoPreview.load(config.textures);
    if(!loaded) {const fallback=document.createElement('p');fallback.className='growth-fallback';fallback.textContent='Portal grows to Blossom with one Pod and one Large Spacer. Explore the builder to see every configuration.';$('.growth-scene').appendChild(fallback);return;}
    $$('#tower .module').forEach((element,i)=>{
      const type=element.dataset.module;
      const piece=window.CatterpodPhotoPreview.create({type,colour:'cloud',height:type==='base'?2:type==='nest'?17:50,scale:3,top:type==='nest',onBase:i===1,label:type.replace('_',' ')});
      if(piece) element.appendChild(piece);
    });
  }
  const moduleObserver=new IntersectionObserver(entries=>{
    if(entries.some(entry=>entry.isIntersecting)){moduleObserver.disconnect();renderModules();}
  },{rootMargin:'700px'});
  moduleObserver.observe(growth);
  const finishObserver=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){finishObserver.disconnect();Object.values(config.finishes).forEach(src=>{const image=new Image();image.src=src;});}},{rootMargin:'700px'});
  finishObserver.observe($('#finishes'));
  $$('[data-finish]').forEach(b=>b.addEventListener('click',()=>{
    const finish=b.dataset.finish,name=finish[0].toUpperCase()+finish.slice(1);
    $('#finish-name').textContent=name;
    const photoFinish=finish;
    $('#finish-photo').src=config.finishes[photoFinish];
    $('#finish-photo').alt=`Blossom in ${name} in a decorated home with a cat`;
    $('.finish-caption').textContent=`Blossom in ${name} · same configuration, your chosen finish.`;
    $$('[data-finish]').forEach(c=>c.setAttribute('aria-pressed',String(c===b)));
  }));
  $('.finish-caption').textContent='Blossom in Cloud · same configuration, your chosen finish.';

  const films=config.films;
  const dialog=$('.film-dialog'),video=dialog.querySelector('video');
  $$('[data-film]').forEach(b=>b.addEventListener('click',()=>{
    const film=films[b.dataset.film];activeFilm=b;const portrait=['joe','asher','mishmish'].includes(b.dataset.film);video.width=portrait?720:1920;video.height=portrait?1280:1080;video.src=film.src;video.poster=film.poster;
    $('.film-caption').textContent=film.caption;dialog.showModal();$('.dialog-close').focus();$('#hero-film').pause();video.play().catch(()=>{});
  }));
  $('.dialog-close').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
  dialog.addEventListener('close',()=>{video.pause();video.removeAttribute('src');video.load();activeFilm?.focus({preventScroll:true});syncHeroPlayback();});
  const heroVideo=$('#hero-film'),heroToggle=$('.hero-play-toggle');
  let heroUserPaused=false,heroInView=false;
  function syncHeroPlayback(){
    if(heroInView&&!heroUserPaused&&!motionOff&&!dialog.open&&document.visibilityState==='visible')heroVideo.play().catch(()=>{});
    else heroVideo.pause();
  }
  function syncHeroLabel(){
    const paused=heroVideo.paused;
    heroToggle.setAttribute('aria-label',paused?'Play hero video':'Pause hero video');
    heroToggle.querySelector('span:first-child').textContent=paused?'▶':'Ⅱ';
    $('.hero-play-label').textContent=paused?'Play video':'Pause video';
  }
  heroVideo.addEventListener('play',syncHeroLabel);heroVideo.addEventListener('pause',syncHeroLabel);
  heroToggle.addEventListener('click',()=>{
    if(heroVideo.paused){heroUserPaused=false;heroVideo.play().catch(()=>{});}
    else{heroUserPaused=true;heroVideo.pause();}
  });
  new IntersectionObserver(entries=>{heroInView=entries[0].isIntersecting;syncHeroPlayback();},{threshold:.15}).observe(heroVideo);
  document.addEventListener('visibilitychange',syncHeroPlayback);
  reduced.addEventListener('change',syncHeroPlayback);
  $('.motion-toggle').addEventListener('click',syncHeroPlayback);
  $('.menu-toggle').addEventListener('click',()=>{
    const isOpen=$('#main-nav').classList.toggle('open');$('.menu-toggle').setAttribute('aria-expanded',String(isOpen));
    $('.menu-toggle').setAttribute('aria-label',isOpen?'Close menu':'Open menu');
  });
  $$('#main-nav a').forEach(a=>a.addEventListener('click',()=>{$('#main-nav').classList.remove('open');$('.menu-toggle').setAttribute('aria-expanded','false');$('.menu-toggle').setAttribute('aria-label','Open menu');}));
  function closeMenu(returnFocus=false){
    $('#main-nav').classList.remove('open');
    $('.menu-toggle').setAttribute('aria-expanded','false');
    $('.menu-toggle').setAttribute('aria-label','Open menu');
    if(returnFocus) $('.menu-toggle').focus();
  }
  root.addEventListener('keydown',event=>{if(event.key==='Escape' && $('#main-nav').classList.contains('open'))closeMenu(true);});
  document.addEventListener('click',event=>{if(!$('.header').contains(event.target))closeMenu();});
  const signup=$('#contact_form');
  function revealSignup(){
    if(location.hash==='#contact_form') signup.querySelector('details').open=true;
  }
  $$('a[href="#contact_form"]').forEach(a=>a.addEventListener('click',()=>{signup.querySelector('details').open=true;}));
  window.addEventListener('hashchange',revealSignup);revealSignup();
  if($('.newsletter-success') || $('#CpNewsletterErrors')){
    signup.querySelector('details').open=true;
    signup.scrollIntoView({block:'center'});
  }
})();
